'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { cn } from '@/lib/utils'

interface CustomerTabsProps {
  customerId: string
  consignmentsCount: number
  invoicesCount: number
}

export function CustomerTabs({ customerId, consignmentsCount, invoicesCount }: CustomerTabsProps) {
  const pathname = usePathname()
  const basePath = `/customers/${customerId}`

  const tabs = [
    { label: 'Overview', href: basePath },
    { label: `Consignments (${consignmentsCount})`, href: `${basePath}/consignments` },
    { label: `Invoices (${invoicesCount})`, href: `${basePath}/invoices` },
    { label: 'Activity', href: `${basePath}/activity` },
  ]

  return (
    <div className="inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground">
      {tabs.map((tab) => {
        const isActive = pathname === tab.href ||
          (tab.href === basePath && pathname === basePath)

        return (
          <Link
            key={tab.href}
            href={tab.href}
            className={cn(
              "inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
              isActive
                ? "bg-background text-foreground shadow-sm"
                : "hover:bg-background/50"
            )}
          >
            {tab.label}
          </Link>
        )
      })}
    </div>
  )
}
